// extracted by mini-css-extract-plugin
export default {"containerBackground":"NewPlanSignupLayout_containerBackground__STLLc","Background":"NewPlanSignupLayout_Background__YUwQR"};